import React, { useState } from 'react';
import MinimalTopBar from './MinimalTopBar';
import MinimalBottomNav from './MinimalBottomNav';
import FloatingActionButton from './FloatingActionButton';
import SidePanel from './SidePanel';

const MinimalLayout = ({ 
  title,
  children,
  onBack,
  showNotifications = true,
  notificationCount = 0,
  storyContent,
  dashboardContent,
  timelineContent,
}) => {
  const [activePanel, setActivePanel] = useState(null);

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Zone 1: Top Bar */}
      <MinimalTopBar 
        title={title}
        onBack={onBack}
        showNotifications={showNotifications}
        notificationCount={notificationCount}
      />

      {/* Zone 2: Main View (Knowledge Zone) */}
      <div className="pt-14 pb-20 px-4 max-w-2xl mx-auto">
        <div className="space-y-4">
          {children}
        </div>
      </div>

      {/* Zone 3: Floating Action Button */}
      {(storyContent || dashboardContent || timelineContent) && (
        <FloatingActionButton
          onPlayStory={() => setActivePanel('story')}
          onDashboard={() => setActivePanel('dashboard')}
          onTimeline={() => setActivePanel('timeline')}
        />
      )}

      {/* Zone 4: Bottom Navigation */}
      <MinimalBottomNav />

      {/* Zone 5: Side Panels */}
      <SidePanel
        isOpen={activePanel === 'story'}
        onClose={() => setActivePanel(null)}
        title="Your Story"
        position="left"
      >
        {storyContent}
      </SidePanel>

      <SidePanel
        isOpen={activePanel === 'dashboard'}
        onClose={() => setActivePanel(null)}
        title="Dashboard"
        position="right"
      >
        {dashboardContent}
      </SidePanel>

      <SidePanel
        isOpen={activePanel === 'timeline'}
        onClose={() => setActivePanel(null)}
        title="Timeline"
        position="bottom"
      >
        {timelineContent}
      </SidePanel>
    </div>
  );
};

export default MinimalLayout;
